import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";
import { getQuarter } from "react-datepicker/dist/date_utils";

export const DashboardApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "DashboardApi",
  tagTypes: ["Dashboard"],
  endpoints: (build) => ({
    getDelayedData: build.query<any, { year: any }>({
      query: ({ year }) => ({
        url: `dashboard/project/delayed/${year}`,
        method: "GET",
      }),
    }),

    getProjectCounts: build.query<any, { year: any }>({
      query: ({ year }) => ({
        url: `dashboard/product-types/project-counts/${year}`,
        method: "GET",
      }),
    }),

    // getCountRequestTypeData: build.query<
    //   any,
    //   { productTypeId: number; year: any }
    // >({
    //   query: ({ productTypeId, year }) => ({
    //     url: `dashboard/count-by-request-type/${productTypeId}/${year}`,
    //     method: "GET",
    //     param: productTypeId,
    //     year,
    //   }),
    // }),

    getQuarterData: build.query<any, { year: any, productTypeId : number }>({
      query: ({ year, productTypeId }) => ({
        url: `dashboard/kpi/completed-project-counts/${year}/${productTypeId}`,
        method: "GET",
        param: year,
      }),
    }),

    getDashboardData: build.query<any, { year: any; productTypeId: number }>({
      query: ({ year, productTypeId }) => ({
        url: `dashboard/data/${productTypeId}/${year}`,
        method: "GET",
      }),
    }),

    getDetailOfQuarter: build.query<any, { year: any; quarter: any, productTypeId : Number  }>({
      query: ({ year, quarter, productTypeId }) => ({
      url: `dashboard/kpi/project-counts/${year}/${quarter}/${productTypeId}`,
        method: "GET",
      }),
    }),

    getLiveProjects: build.query<any, {year: any}>({
      query: ({year}) => ({
        url: `dashboard/live/project-counts/${year}`,
        method: "GET",
      }),
    }),

    getProjectCountsData: build.query<any, { year: any, productTypeId: number }>({
      query: ({ year, productTypeId }) => ({
        url: `dashboard/project-counts/${year}/${productTypeId}`,
        method: "GET",
      }),
    }),

    getOtdData: build.query<any, { year: string }>({
      query: ({ year }) => ({
        url: `dashboard/project-otd/${year}`,
        method: "GET",
      }),
    }),

    getPendingApproval: build.query<any, void>({
      query: () => ({
        url: "dashboard/pending-approvals",
        method: "GET",
      }),
    }),

    getDashboardDelayDetails: build.query<any, { year: string; productTypeId: number }>({
      query: ({ year, productTypeId }) => ({
        url: `dashboard/delayed-projects/${productTypeId}/${year}`,
        method: "GET",
      }),
    }),

    getDashboardCriticalDetails: build.query<any, { year: string; productTypeId: number }>({
      query: ({ year, productTypeId }) => ({
        url: `dashboard/critical-priority-projects/${productTypeId}/${year}`,
        method: "GET",
      }),
    }),


  }),
});

export const {
  useLazyGetDelayedDataQuery,
  useGetProjectCountsQuery,
  // useLazyGetCountRequestTypeDataQuery,
  useLazyGetQuarterDataQuery,
  useLazyGetDashboardDataQuery,
  useLazyGetDetailOfQuarterQuery,
  useLazyGetLiveProjectsQuery,
  useLazyGetProjectCountsDataQuery,
  useGetOtdDataQuery,
  useGetPendingApprovalQuery,
  useLazyGetDashboardDelayDetailsQuery,
  useLazyGetDashboardCriticalDetailsQuery,
} = DashboardApi;
